import { contentRemove } from "@/reducer/contentSlice";
import { selectUser } from "@/reducer/userslice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Content } from "@/types/content";
import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  useDisclosure,
} from "@chakra-ui/react";
import {
  RiDeleteBinLine,
  RiDownload2Line,
  RiSendPlaneLine,
  RiShareForwardBoxFill,
  RiImageLine,
  RiZoomInFill,
} from "@remixicon/react";
import { useCallback, useState } from "react";
import SmrDeleteModal from "./deletemodal";
import SmrShareModal from "./sharemodal";
import SmrPublish from "./smrpublish";
import Client4 from "@/services/api/client4";
import { selectCurrentImage, setCurrentImage } from "@/reducer/designslice";

type Props = {
  content: Content;
  handleBigImage: (content: Content) => void;
};

const CurrentSmrContentItem = (props: Props) => {
  const { content, handleBigImage } = props;

  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const currentImage = useAppSelector(selectCurrentImage);

  const [hovered, setHovered] = useState(false);
  const [currentContentId, setCurrentContentId] = useState("");
  const DelControl = useDisclosure();
  const ShareControl = useDisclosure();
  const PublishControl = useDisclosure();

  const linkSrc = "https://www/aldgptai.com?rand_code=" + user.rand_code;


  const generateRandomCode = (length: number): string => {
    let code = "";
    for (let j = 0; j < length; j++) {
      code += Math.floor(Math.random() * 10); // 生成 0-9 之间的随机数
    }
    return code;
  };

  const OnDownload = useCallback(async () => {
    if (!content) {
      return;
    }
    try {
      const response = await fetch(content.image_url as string);
      const blob = await response.blob();
      const link = document.createElement("a") as HTMLAnchorElement;
      link.href = URL.createObjectURL(blob);
      link.download = generateRandomCode(9) + ".png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error fetching the image", error);
    }
  }, [content]);

  const OnDelete = (content: Content) => {
    setCurrentContentId(content.id);
    DelControl.onOpen();
  };
  const handleOnDelete = async () => {
    dispatch(contentRemove(currentContentId));
    Client4.deleteContent(currentContentId);
    if(currentImage.id === currentContentId){
      dispatch(setCurrentImage({} as Content ));
    }
      DelControl.onClose();
    };

  const handleOnShare = () => {
    ShareControl.onOpen();
  };

  const OnPublish = (content: Content) => {
    setCurrentContentId(content.id);
    PublishControl.onOpen();
  };

  return (
    <Box
      sx={{
        width: "full",
        height: "full",
        position: "absolute",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* {content.smrpicture && (
        <SmroomImageComparing
          image={content}
          compareImageSrc={content.smrpicture}
        />
      )} */}
      <Image w="100%" h="100%" objectFit={"contain"} src={content.image_url} />
      {hovered && (
        <Box
          position={"absolute"}
          w="100%"
          h="100%"
          top={0}
          left={0}
          background={
            "linear-gradient(180deg, rgba(0, 0, 0, 0.79) 0%, rgba(0, 0, 0, 0) 12.39%, rgba(0, 0, 0, 0) 79.5%, rgba(0, 0, 0, 0.7) 96%)"
          }
        >
          <Flex
            w="100%"
            h="100%"
            justifyContent={"center"}
            alignItems="center"
            cursor={"pointer"}
            onClick={() => handleBigImage(content)}
          >
            <RiZoomInFill size="24px" />
          </Flex>
          <Flex
            justifyContent={"space-between"}
            alignItems="center"
            w="100%"
            position={"absolute"}
            top="0"
            left={"0"}
            p="10px"
          >
            <HStack>
              <Button
                p="6px"
                h="38px"
                bg="#1E253F"
                color={"#FFFFFF"}
                fontSize="14px"
                fontWeight={"normal"}
                borderRadius={"4px"}
                _hover={{
                  bg: "#303853",
                }}
                leftIcon={<RiDownload2Line color="#FFFFFF" size="16px" />}
                onClick={OnDownload}
              >
                下载
              </Button>
              <Button
                p="6px"
                h="38px"
                bg="#1E253F"
                color={"#FFFFFF"}
                fontSize="14px"
                fontWeight={"normal"}
                borderRadius={"4px"}
                _hover={{
                  bg: "#303853",
                }}
                leftIcon={<RiDeleteBinLine color="#FFFFFF" size="16px" />}
                onClick={() => OnDelete(content)}
              >
                删除
              </Button>
            </HStack>
            <HStack>
              <Button
                p="6px"
                h="38px"
                bg="#1E253F"
                color={"#FFFFFF"}
                fontSize="14px"
                fontWeight={"normal"}
                borderRadius={"4px"}
                _hover={{
                  bg: "#303853",
                }}
                leftIcon={<RiSendPlaneLine color="#FFFFFF" size="16px" />}
                onClick={() => OnPublish(content)}
              >
                发布
              </Button>
              <Button
                p="6px"
                h="38px"
                bg="#1E253F"
                color={"#FFFFFF"}
                fontSize="14px"
                fontWeight={"normal"}
                borderRadius={"4px"}
                _hover={{
                  bg: "#303853",
                }}
                leftIcon={<RiShareForwardBoxFill color="#FFFFFF" size="16px" />}
                onClick={handleOnShare}
              >
                分享
              </Button>
            </HStack>
          </Flex>
          <Flex
            justifyContent={"end"}
            w="100%"
            position={"absolute"}
            bottom="0"
            left={"0"}
            p="10px"
          >
            <Button
              borderRadius={"10px"}
              ml={"10px"}
              color="#DCE0EB"
              width={"101px"}
              height={"38px"}
              fontSize="12px"
              background={"linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"}
              _hover={{
                background: "linear-gradient(90deg, #496AE1 0%, #66E8E0 100%)",
              }}
              leftIcon={<RiImageLine color="#FFFFFF" size="16px" />}
            >
              图生漫游
            </Button>
          </Flex>
        </Box>
      )}

      {currentContentId && (
        <SmrDeleteModal
          isOpen={DelControl.isOpen}
          onClose={DelControl.onClose}
          onDelete={handleOnDelete}
        />
      )}
      <SmrShareModal
        isOpen={ShareControl.isOpen}
        onClose={ShareControl.onClose}
        bannerSrc={content.image_url}
        linkSrc={content.image_url}
      />

      {currentContentId && (
        <SmrPublish
          isOpen={PublishControl.isOpen}
          onClose={PublishControl.onClose}
          contentId={currentContentId}
        />
      )}
    </Box>
  );
};

export default CurrentSmrContentItem;
